module.exports = __webpack_public_path__ + "img/major9.f43591c6.png";